import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Col,
  Row,
  Input,
  Button,
  message,
  Modal,
  Tag,
  Divider,
  Switch,
  Typography,
  Checkbox,
  Result,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ClickableTextButton from "components/ClickableTextButton/ClickableTextButton";
import Title from "components/Title/Title";
import { withAppContext } from "contexts/AppContext/AppContext";
import { buildBaseUri } from "utils/routes";
import moment from "moment";
import Currency from "react-currency-formatter";
import { PrimaryColor, ScreenSize } from "utils/constants";
import "./buttonRGB.css";
import Locale from "react-intl-universal";

const BillingCancelPage = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onBackButtonClick = () => history.push("/billing-subscription");

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div>
      <Row
        justify="space-between"
        align="middle"
        style={{ marginBottom: "32px" }}
      >
        <ClickableTextButton
          text={Locale.get("Billing.billingSub.back")}
          onClick={onBackButtonClick}
          showIcon={true}
          type="back"
        />
      </Row>

      <Result
        status="error"
        title={Locale.get("Billing.billingSub.paymentCancel")}
        subTitle=""
        extra={
          [
            //   <Button type="primary" key="">
            //     Go Back
            //   </Button>,
          ]
        }
      />
    </div>
  );
};

export default withAppContext(BillingCancelPage);
